<app-page-title [title]="'Reporting a Test Day Issue'"></app-page-title>
<br />
<div class="row">
    <div class="col-md-12">
        <div class="panel">
            <p>
                If you experienced an issue on your test day that may have impacted your performance, you must report it using the form below within {{testInfo.hoursLimitForTestTakerComplaint}} hours of your test.
                <br />
                No corrective action will be taken for issues that are reported more than {{testInfo.hoursLimitForTestTakerComplaint}} hours after the test sitting or after scores have been released, whichever comes first.
            </p>
        </div>
    </div>
</div>
<br />
<h4>Test Information</h4>
<div
    class="row pt-2"
    *ngIf="testInfo"
>
    <div class="col-md-6">
        <p>Registration Number: {{regId}}</p>
        <p [hidden]="testInfo.isWebDelivery">Test Centre: {{testInfo.testCentreName}}</p>
        <p [hidden]="testInfo.isWebDelivery">Test Centre Location: {{testInfo.testCentreLocation}}</p>
        <p *ngIf="testInfo.isWebDelivery">Web Delivered Test</p>
    </div>
    <div class="col-md-6">
        <p>Test Date: {{testInfo.testDateTime | date}}</p>
        <p>Test Type: {{testInfo.testTypeName}}</p>
    </div>
</div>
<br />
<h4>Submit Your Report</h4>
<div class="survey pt-2">
    <form name="complaint-form">
        <div class="form-group surveyQuestion">
            <label>Briefly describe your issue ({{ maxWordsForSummary }} word maximum)</label>
            <textarea
                class="form-control"
                [(ngModel)]="comments"
                name="comments"
                rows="1"
            ></textarea>
        </div>
        <div class="form-group surveyQuestion">
            <label>Please add additional comments ({{ maxWordsForAdditional }} word maximum)</label>
            <textarea
                class="form-control"
                [(ngModel)]="additionalComments"
                name="additionalComments"
                rows="5"
            ></textarea>
        </div>
    </form>
</div>
<div class="row">
    <div class="col-md-12 bottomButtons">
        <a
            [routerLink]="['/my-account']"
            class="btn btn-primary m-1"
        >Back</a>
        <button
            type="button"
            name="submitBtn"
            class="btn btn-primary m-1"
            [disabled]="!(comments && additionalComments)"
            (click)="
            displayModal()"
        >
            <span class="glyphicon glyphicon-plus"></span> Submit
        </button>
    </div>
</div>
<app-modal
    #scoreWarning
    title="Note"
    [body]="warningMesssage"
    (clickPositive)="submitComplaint()"
    isConfirm="true"
>
</app-modal>
